export const useWebpackChunkHandler = () => {
  /**
   * Generates a lazy retry function for the given component import.
   *
   * @param {function} componentImport - The function that imports the component.
   * @return {Promise} A promise that resolves to the imported component or rejects with an error.
   */
  const handleChunkLoadError = (componentImport) =>
    new Promise((resolve, reject) => {
      const storageKey = `retry-lazy-refreshed${window.btoa(componentImport.toString())}`;

      const hasRefreshed = JSON.parse(window.sessionStorage.getItem(storageKey) || 'false');

      componentImport()
        .then((component) => {
          window.sessionStorage.setItem(storageKey, 'false');

          if (component === undefined) {
            window.sessionStorage.setItem(storageKey, 'true');
            return window.location.reload(); // refresh the page
          }
          resolve(component);
        })
        .catch((error) => {
          console.log('error loading component', error);

          if (!hasRefreshed) {
            // not been refreshed yet
            window.sessionStorage.setItem(storageKey, 'true');
            window.location.reload();
          }
          reject(error); // Default error behaviour as already tried refresh
        });
    });

  return {
    handleChunkLoadError
  };
};
